import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { EventService } from '@shared/event.service';
import { TranslateService } from '@ngx-translate/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root'
})
export class TokenCheckGuard implements CanActivateChild {
  constructor(
    private _eventService: EventService,
    private _translateService: TranslateService,
    private _oauthService: OAuthService
  ) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Not signed-in
    if (!this._oauthService.hasValidAccessToken()) {
      this._eventService.error(this._translateService.instant('error-message.please-login'));
      // Session may already be invalidated - clear local tokens and start fresh login
      this._oauthService.logOut(true);
      this._oauthService.initLoginFlow();
      return false;
    }
    return true;
  }
}
